import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-econ-research',
  templateUrl: './econ-research.component.html',
  styleUrls: ['./econ-research.component.less']
})
export class EconResearchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
